import { Component, AfterViewInit, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-video-background',
  templateUrl: './video-background.component.html',
  styleUrls: ['./video-background.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VideoBackgroundComponent {
  startTime = this.randomIntFromInterval(0, 173);
  player: YT.Player;
  id = 'dPRyvBtj76U';
  showPlayer = false;
  playerVars = {
    controls: 0,
    showinfo: 0,
    rel: 0,
    autoplay: 1,
    mute: 1,
    volume: 0,
    loop: 1,
    start: this.startTime,
    t: this.startTime
  };

  onStateChange(event) {
    if (event.data === 1) {
      this.showPlayer = true;
    }
    if (event.data === YT.PlayerState.ENDED) {
      this.player.playVideo();
    }
  }

  savePlayer(player) {
    this.player = player;
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

}




// WEBPACK FOOTER //
// ./src/app/view/components/video-background/video-background.component.ts